import { BASIC } from 'constants/MembershipLevels';

const isPremiumProfile = profile => profile.membershipLevel === BASIC;

export default isPremiumProfile;
